var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.58321 10.7755H5.42892C5.87339 10.7755 6.1672 10.4755 6.1672 10.0537V8.65998C6.1672 8.23055 5.87339 7.93677 5.42892 7.93677H3.58321C3.13874 7.93677 2.84494 8.23055 2.84494 8.65998V10.0537C2.84494 10.4755 3.13874 10.7755 3.58321 10.7755ZM0.846154 5.46773H16.9858V3.7061H0.846154V5.46773ZM2.47128 13.6143H15.3531C16.9867 13.6143 17.8244 12.7814 17.8244 11.1739V3.02552C17.8244 1.41803 16.9867 0.578957 15.3531 0.578957H2.47128C0.845254 0.578957 0 1.41803 0 3.02552V11.1739C0 12.7814 0.845254 13.6143 2.47128 13.6143ZM2.55685 12.1384C1.85639 12.1384 1.47595 11.777 1.47595 11.045V3.1557C1.47595 2.42239 1.85639 2.05491 2.55685 2.05491H15.2675C15.9557 2.05491 16.3484 2.42239 16.3484 3.1557V11.045C16.3484 11.777 15.9557 12.1384 15.2675 12.1384H2.55685Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.ab7780a6.svg";
export { ForwardRef as ReactComponent };